import { Component, EventEmitter, Output } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';

// Values passed in via `initialState` when the modal is opened.
export interface MinMaxScaleModalParams {
  title?: string;
  min: number | null;
  max: number | null;
}

// Result emitted back to the caller. A null bound means "autoscale that end";
// both null means "no manual scaling".
export interface MinMaxScaleResult {
  min: number | null;
  max: number | null;
}

// Small dialog for entering a Y-axis min/max range. Opened by the eChart
// component when the user clicks a Y-axis's values.
@Component({
  standalone: false,
  selector: 'min-max-scale-modal',
  templateUrl: './min-max-scale-modal.component.html',
  styleUrls: ['./min-max-scale-modal.component.scss']
})
export class MinMaxScaleModalComponent implements MinMaxScaleModalParams {
  // Fired when the user applies; the caller subscribes to this.
  @Output() onApply = new EventEmitter<MinMaxScaleResult>();

  title = 'Set Y-Axis Range';
  min: number | null = null;
  max: number | null = null;

  // Only allow dragging while the pointer is over the header (matches the other
  // modals in this app).
  modalDragOn = false;

  constructor(public bsModalRef: BsModalRef) {}

  setDragOn(on: boolean): void {
    this.modalDragOn = on;
  }

  apply(): void {
    this.onApply.emit({ min: this.emptyToNull(this.min), max: this.emptyToNull(this.max) });
    this.bsModalRef.hide();
  }

  // Empty both fields (does not close) so applying removes manual scaling.
  clear(): void {
    this.min = null;
    this.max = null;
  }

  cancel(): void {
    this.bsModalRef.hide();
  }

  // A cleared number input yields null or ''; normalize both to null.
  private emptyToNull(value: number | null): number | null {
    return (value == undefined || value.toString().trim() === '') ? null : value;
  }
}
